import * as React from 'react'
import {
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import {
  NavLink as RouterLink,
  NavLinkProps as RouterLinkProps,
  useMatch,
  useResolvedPath,
} from 'react-router-dom'
import { Box } from '@mui/material'
import { useDrawerStore } from 'store'

interface ListItemLinkProps {
  icon?: React.ReactElement
  primary: string
  to: string
  open: boolean
  end?: boolean
}

const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(function Link(
  itemProps,
  ref
) {
  return <RouterLink ref={ref} {...itemProps} role={undefined} />
})

export default function DrawerLink(props: ListItemLinkProps) {
  const { icon, primary, to, open, end = true } = props
  const resolved = useResolvedPath(to)
  const isActive = useMatch({ path: resolved.pathname, end: end })

  const theme = useTheme()
  const MATCHES_SMD = useMediaQuery(theme.breakpoints.down('sm'))
  const setOpen = useDrawerStore((state) => state.setOpen)
  const handleClick = () => {
    if (MATCHES_SMD) {
      setOpen(false)
    }
  }
  const ifOpen = MATCHES_SMD ? '196px' : '100%'
  return (
    <Box component="li" sx={{ width: '100%' }}>
      <ListItemButton
        component={Link}
        to={to}
        onClick={handleClick}
        sx={{
          minWidth: '56px',
          maxWidth: open ? ifOpen : '56px',
          textAlign: 'center',
          height: '56px',
          mb: '40px',
          ml: open ? 'initial' : '12px',
          borderRadius: '12px',
          boxShadow: 26,
          bgcolor: isActive ? 'primary.main' : 'common.white',
          px: 0,
          transition: (theme) => theme.transitions.create(['border-color']),
          '&:hover': {
            bgcolor: isActive ? 'primary.main' : 'initial',
            boxShadow:
              '3px 3px 8px rgba(9, 9, 9, 0.3), 4px 4px 6px 0px #FFFFFF66 inset',
            '&:before': {
              content: '" "',
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              border: (theme) =>
                `2px solid ${
                  isActive ? 'initial' : theme.palette.primary.main
                }`,
              borderRadius: '12px',
              pointerEvents: 'none',
            },
            '&:active': {
              borderColor: 'transparent',
              boxShadow: 'inset 8px 6px 4px rgba(0,0,0, 0.1)',
              bgcolor: 'primary.main',
            },
          },
        }}
      >
        <ListItemText
          primary={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  mr: open ? { xs: '16px', sm: '20px' } : 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {icon}
              </Box>
              {open ? (
                <Box
                  sx={{
                    fontSize: { xs: '16px', sm: '18px' },
                  }}
                >
                  {primary}
                </Box>
              ) : null}
            </Box>
          }
        />
      </ListItemButton>
    </Box>
  )
}
